import React from "react";
import { Link } from "react-router-dom";

import LogoImg from "../../../assets/images/logo.png";
import { loginPath } from "../../../teacherStore";

import styles from "./ResetPasswordCompleted.module.scss";

const ResetPasswordCompleted: React.FC = () => {
  return (
    <div className="d-flex">
      <div className={styles.content}>
        <p className={styles.logo}>
          <img src={LogoImg} alt="brand logo" />
        </p>
        <div className={styles.wrapper}>
          <h4 className={styles.message}>
            <p>
              入力したメールアドレスに新しいパスワード設定のURLを送信しました。
              <br />
              メール受信を確認後、下記の操作を行なってください。
            </p>
          </h4>
          <div className={styles.list}>
            <p>
              ・新しく届いたメールのパスワード設定のURLにアクセス
              <br />
              ・新しいパスワードの設定
              <br />
              ・パスワード設定後、ログインができるか確認
            </p>
          </div>
          <div className={styles.notice}>
            <p>
              ※URLの有効期限は2週間です。
              <br />
              　期限が過ぎた場合は、パスワードリセットをやり直してください。
            </p>
          </div>
          <div className={styles.forgotPasswordLink}>
            <Link to={loginPath} className={styles.forgotPassword}>
              ログイン画面に戻る
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordCompleted;
